import LocalizedStrings from "react-localization";
import { LangContext } from "./App";
import { useContext, useCallback } from "react";

const txts = {};
txts.fr = {};
txts.de = {};
txts.it = {};

txts.fr[`Lorem ipsums`] = "Hello darkness, my old friend";
txts.fr[`Cambia lingua (attuale=0)!`] = `Cambia lingua (attuale=0)! DE`;
txts.fr[`Lorem ipsum FR`] = `De la salade croquante`;
txts.fr[`Lorem ipsum chicken`] = `Du poulet savoureux`;
txts.fr[`Lorem ipsum chicken2`] = `avec panure croustillante`;
txts.fr[`Lorem ipsum sauce`] = `Une sauce Habanero super relevée`;
txts.fr[`Lorem ipsum bread`] = `Un petit pain`;
txts.fr[`Lorem ipsum bread2`] = ` brioché tout léger`;
txts.fr[`SVQTkwKKQ2o`] = `4pgnbvQ9bU4`;

txts.de[`Lorem ipsums`] = "Hello darkness, my old friend";
txts.de[`Cambia lingua (attuale=0)!`] = `Cambia lingua (attuale=0)! DE`;
txts.de[`Lorem ipsum bread`] = `Luftiges `;
txts.de[`Lorem ipsum bread2`] = ` Brioche-Brötche`;
txts.de[`Lorem ipsum sauce`] = `Extra Spicy Habanero-Sauce`;
txts.de[`Lorem ipsum chicken`] = `Zartes Chicken mit `;
txts.de[`Lorem ipsum chicken2`] = ` knuspriger Panade`;
txts.de[`Lorem ipsum FR`] = `Knackiger Salat `;
txts.de[`SVQTkwKKQ2o`] = `4pgnbvQ9bU4`;

txts.it[`Lorem ipsums`] = "Hello darkness, my old friend IT";
txts.it[`Cambia lingua (attuale=0)!`] = `Cambia lingua (attuale=0)! IT`;
txts.it[`Lorem ipsum FR`] = `Insalata croccante`;
txts.it[`Lorem ipsum chicken`] = `Succulento pollo con `;
txts.it[`Lorem ipsum chicken2`] = ` panatura croccante`;
txts.it[`Lorem ipsum sauce`] = `Una salsa Habanero extra piccante`;
txts.it[`Lorem ipsum bread`] = `Un panino  `;
txts.it[`Lorem ipsum bread2`] = `brioche soffice`;
txts.it[`SVQTkwKKQ2o`] = `TFtPNL_oucg`;

// const strings = new LocalizedStrings(txts);

export default function useTxt() {
  const [lang, setLang] = useContext(LangContext);
  return useCallback(
    (t) => {
      // console.log(t, lang, (lang && txts[lang][t]) || t);
      return (lang && txts[lang][t]) || t;
    },
    [lang]
  );
}
